import React, { useState, useEffect } from 'react';

function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isAppInstalled, setIsAppInstalled] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI to notify the user they can add to home screen
      // For example, show your install button
      setIsAppInstalled(false); // Make sure the install button is visible
    };

    // Check if the app is already installed
    // This is a basic check; more robust checks might be needed
    if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone) {
      setIsAppInstalled(true);
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      const { outcome } = await deferredPrompt.userChoice;

      // Optionally, send analytics to track if user accepted the prompt
      if (outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
        setIsAppInstalled(true); // Update state to reflect installation
      } else {
        console.log('User dismissed the A2HS prompt');
      }

      // We no longer need the prompt. Clear it.
      setDeferredPrompt(null);
    }
  };

  if (isAppInstalled) {
    return ;
  }

  if (!deferredPrompt) {
    // If deferredPrompt is null, it means the beforeinstallprompt event hasn't fired yet
    // or the app is not installable (e.g., missing manifest, not on HTTPS)
    return <p className='d-none'>Loading installation options...</p>;
  }

  return (
    <button className="ml-3 btn custom-blue-button" type="button" onClick={handleInstallClick}>
      Install Clientwiseportal!
    </button>
  );
}

export default InstallPWAButton;